var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gl-wrap" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "gl-card" },
      [
        _c("div", { staticClass: "gl-brand" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("h1", { staticClass: "gl-title" }, [
            _vm._v(
              _vm._s(_vm.mode === "bootstrap" ? "初始化管理员" : "欢迎登录")
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "gl-sub" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.mode === "bootstrap"
                    ? "系统首次启动，请创建管理员账号"
                    : "请使用你的账号继续"
                ) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.statusError
          ? _c("el-alert", {
              staticClass: "gl-alert",
              attrs: {
                type: "error",
                title: _vm.statusError,
                closable: false,
                "show-icon": "",
              },
            })
          : _vm.mode === "bootstrap"
          ? _c("el-alert", {
              staticClass: "gl-alert",
              attrs: {
                type: "warning",
                title: "系统尚未初始化，请先创建管理员账号",
                closable: false,
                "show-icon": "",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "el-form",
          {
            staticClass: "gl-form",
            attrs: { model: _vm.form },
            nativeOn: {
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "用户名",
                    "prefix-icon": "el-icon-user",
                    autocomplete: "off",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onSubmit.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.form.username,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "username", $$v)
                    },
                    expression: "form.username",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  attrs: {
                    type: "password",
                    placeholder: "密码",
                    "prefix-icon": "el-icon-key",
                    autocomplete: "off",
                    "show-password": "",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onSubmit.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.form.password,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "password", $$v)
                    },
                    expression: "form.password",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "gl-submit",
                attrs: { loading: _vm.submitting },
                on: { click: _vm.onSubmit },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.mode === "bootstrap" ? "创建并继续" : "登 录") +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "gl-foot" }, [
          _c(
            "span",
            { staticClass: "gl-status", class: { "is-ok": _vm.bootstrapped } },
            [
              _c("i", {
                class: _vm.bootstrapped
                  ? "el-icon-success"
                  : "el-icon-warning-outline",
              }),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.bootstrapped ? "服务已初始化" : "服务未初始化") +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "gl-refresh",
              attrs: { type: "button", disabled: _vm.statusLoading },
              on: { click: _vm.loadStatus },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.statusLoading ? "检测中…" : "重新检测") +
                  "\n      "
              ),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "gl-bg", attrs: { "aria-hidden": "true" } },
      [
        _c("span", { staticClass: "gl-blob gl-blob--1" }),
        _vm._v(" "),
        _c("span", { staticClass: "gl-blob gl-blob--2" }),
        _vm._v(" "),
        _c("span", { staticClass: "gl-blob gl-blob--3" }),
        _vm._v(" "),
        _c("span", { staticClass: "gl-grid" }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "gl-logo" }, [
      _c("i", { staticClass: "el-icon-lock" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }